const firebaseConfig = {
  apiKey: "AIzaSyDu73YyR2N9iWQWMiednfynItWhqeB6pUM",
  authDomain: "paint-shack.firebaseapp.com",
  projectId: "paint-shack",
  storageBucket: "paint-shack.appspot.com",
  messagingSenderId: "697627877494",
  appId: "1:697627877494:web:a5ff803521d41fc77d3f57"
};

  export default firebaseConfig;